import * as React from 'react';

function SvgWalletIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.417 6.417H16.5V5.5a2.75 2.75 0 00-2.75-2.75H4.584a2.75 2.75 0 00-2.75 2.75v11a2.75 2.75 0 002.75 2.75h12.833a2.75 2.75 0 002.75-2.75V9.167a2.75 2.75 0 00-2.75-2.75zM4.583 4.583h9.167a.916.916 0 01.917.917v.917H4.583a.917.917 0 110-1.834zm13.75 9.167h-.916a.917.917 0 010-1.833h.916v1.833zm0-3.667h-.916a2.75 2.75 0 000 5.5h.916v.917a.917.917 0 01-.916.917H4.583a.917.917 0 01-.916-.917V8.094c.294.104.604.156.917.156h12.833a.917.917 0 01.916.917v.916z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgWalletIcon;
